import { Link } from 'react-router-dom';

interface NotFoundProps {
  /** Where the "Back home" button sends the user. */
  homeTo?: string;
  homeLabel?: string;
}

/**
 * Generic 404 page used by both the dashboard and portal shells.  Stays
 * consistent with the brand: gradient mark, oversized display number, a
 * single primary CTA, no decoration.
 */
export function NotFound({
  homeTo = '/dashboard/',
  homeLabel = 'Back to the dashboard',
}: NotFoundProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg)] px-6 py-12">
      <div className="w-full max-w-[520px] text-center prism-enter">
        <div
          aria-hidden="true"
          className="mx-auto mb-8 h-14 w-14 rounded-[6px] bg-gradient-blue-teal"
        />
        <p className="eyebrow mb-3">Error 404</p>
        <h1 className="display text-[88px] sm:text-[112px]">404</h1>
        <h2 className="mt-2 text-[22px] font-semibold leading-tight text-[var(--color-ink)]">
          We Couldn't Find That Page.
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-[var(--color-ink-soft)]">
          The link may be wrong, the resource may have moved, or your role
          may not allow access to it. The team has logged the request.
        </p>
        <Link
          to={homeTo}
          className="mt-8 inline-flex min-h-[48px] items-center justify-center rounded-[4px] border border-[var(--color-primary)] bg-[var(--color-primary)] px-7 py-3 font-sans text-[15px] font-semibold text-white transition-colors hover:bg-[var(--color-primary-hover)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-primary)]"
        >
          {homeLabel}
        </Link>
      </div>
    </div>
  );
}
